import { ModalConfirmation } from '@lideralia/alife-uikit/dist/organisms/Modals/Confirmation';
import React from 'react';

export const ConfirmationTemplate = (props) => <ModalConfirmation {...props} />;
